import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import HyperLinkCell from './Hyperlink';

export const imgLinks = [
    { imageSrc: 'https://test.autoinfo.com.au/product/862FEA35482730D97EF5B6DE4B3DC1A43D8A2D2D2CCF5BB4EEFE48222D5F30F1.jpg' },
    { imageSrc: 'https://test.autoinfo.com.au/product/554320B12759E8637545AC0FB0B0956ED83825F914B3F6631DFB54C2B50E44BEF24A0881F2E52841312A11613B1EC37B.jpg' },
    { imageSrc: 'https://test.autoinfo.com.au/product/554320B12759E8637545AC0FB0B0956EB8006A647B9B068685CE0386ED6EFAD2D958FC08151F66BA0915FE4E40E8BDF2.jpg' },
    { imageSrc: 'https://test.autoinfo.com.au/product/21CB6360E1281C4B9F70C859C44844E3E39F1A92D9F5E92E5146C76443F853E3C2B7E873C01E6E8D9E96D27B8A6AD1AF.jpg' },
    { imageSrc: 'https://test.autoinfo.com.au/product/F0E2F1EC747F04472070A6C79401EE37A140AC9511BCD83ECFF5AC407A54933166EAE24340DA797623729AAF6C2B967A.jpg' },
];

export const QUANTITY_WIDTH = 105;

export const columns = [
    {
        dataField: 'Description',
        caption: 'Dimensions',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1
    },
    {
        dataField: 'DimensionDisplay',
        caption: 'Descriptions',
        width: QUANTITY_WIDTH,
    }
];

export const columnsNotes = [
    {
        dataField: 'NotePath',
        caption: 'Descriptions',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        cellComponent: HyperLinkCell,
    },
];

export const Specifications = [
    { id: 1, dimension: 'Diameter', description: '250 mm' },
    { id: 2, dimension: 'Height', description: '52.2 mm' },
    { id: 3, dimension: 'Thickness', description: '30 mm' },
    { id: 4, dimension: 'Centre Hole', description: '67 mm' },
    { id: 5, dimension: 'Minimum Thickness', description: '28 mm' },
    { id: 6, dimension: 'Hub Reg', description: '67 mm' },
    { id: 7, dimension: 'Bolt Hole Circle', description: '114.3 mm' },
    { id: 8, dimension: 'Bolt Hole Qty', description: '5' },
    { id: 9, dimension: 'Overall Height', description: '52.2 mm' },
    { id: 10, dimension: 'Weight', description: '7.5 kg' },
    { id: 11, dimension: 'Disc Vent', description: 'Vented' },
    { id: 12, dimension: 'Disc Type', description: 'Slotted' },
    { id: 13, dimension: 'Finish', description: 'Black Hat' },
    { id: 14, dimension: 'Diameter', description: '250 mm' },
    { id: 15, dimension: 'Height', description: '52.2 mm' },
    { id: 16, dimension: 'Thickness', description: '30 mm' },
    { id: 17, dimension: 'Centre Hole', description: '67 mm' },
    { id: 18, dimension: 'Minimum Thickness', description: '28 mm' },
    { id: 19, dimension: 'Hub Reg', description: '67 mm' },
    { id: 20, dimension: 'Bolt Hole Circle', description: '114.3 mm' },
    { id: 21, dimension: 'Bolt Hole Qty', description: '5' },
    { id: 22, dimension: 'Overall Height', description: '52.2 mm' },
    { id: 23, dimension: 'Weight', description: '7.5 kg' },
    { id: 24, dimension: 'Disc Vent', description: 'Vented' },
    { id: 25, dimension: 'Disc Type', description: 'Slotted' },
    { id: 26, dimension: 'Finish', description: 'Black Hat' },
];

export const ProductId = 285;
export const PartId = 3399673;
